module.exports = __webpack_public_path__ + "static/media/ic_logistics.1a6a5303.svg";